import { render, staticRenderFns } from "./ProductBundlePrice.vue?vue&type=template&id=19fe3517"
import script from "./ProductBundlePrice.vue?vue&type=script&lang=js"
export * from "./ProductBundlePrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports